/**
 * Shades a color, `amt` is a percentage.
 *
 * `amt`: Negative values make the color lighter, while positive values make the color darker.
 */
export const shadeColor = (color, amt) => {
  const num = parseInt(color.slice(1), 16);
  const bounded = x => Math.min(255, Math.max(0, x));
  const R = (num >> 16) + amt; // eslint-disable-line no-bitwise
  const G = ((num >> 8) & 0x00ff) + amt; // eslint-disable-line no-bitwise
  const B = (num & 0x0000ff) + amt; // eslint-disable-line no-bitwise
  const nR = bounded(R) * 0x10000;
  const nG = bounded(G) * 0x100;
  const nB = bounded(B);
  return `#${(0x1000000 + nR + nG + nB) // eslint-disable-line no-nested-ternary
    .toString(16)
    .slice(1)}`;
};

export const hexToRgb = (() => {
  const re1 = /^#?([\dabcdefABCDEF])([\dabcdefABCDEF])([\dabcdefABCDEF])$/;
  const re2 = /^#?([\dabcdefABCDEF]{2})([\dabcdefABCDEF]{2})([\dabcdefABCDEF]{2})$/;
  const memo = {};
  return hex => {
    if (memo[hex]) {
      return memo[hex];
    }
    const matches = re1.exec(hex) || re2.exec(hex);
    if (!matches || matches.length !== 4) {
      throw new Error(`Cannot convert ${hex} to rgb.`);
    }
    const r = parseInt(matches[1], 16);
    const g = parseInt(matches[2], 16);
    const b = parseInt(matches[3], 16);
    const res = { r, g, b };
    memo[hex] = res;
    return res;
  };
})();

export const hexToRgbaString = (hex, alpha) => {
  if (hex === 'transparent') {
    return hex;
  }

  const r = hexToRgb(hex);
  return `rgba(${r.r}, ${r.g}, ${r.b}, ${alpha})`;
};

export const blendHexColors = (color1, color2, amount, alpha = 1.0) => {
  const rgb1 = hexToRgb(color1);
  const rgb2 = hexToRgb(color2);
  const newRgb = [
    (1 - amount) * rgb1.r + amount * rgb2.r,
    (1 - amount) * rgb1.g + amount * rgb2.g,
    (1 - amount) * rgb1.b + amount * rgb2.b,
  ];
  return `rgba(${newRgb.join(',')},${alpha})`;
};
